import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCompressJpegConfig } from '@/data/landingConfig/landingCompressJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CompressJpeg } from './schemaObject';

interface Props {}
const CompressJpeg: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CompressJpeg} />
			<LandingTemplate
				data={landingCompressJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default CompressJpeg;
